<script lang="ts">
  import Skeleton from "./Skeleton.svelte";

  export let rows: number = 5;
</script>

<div class="table">
  {#each Array(rows) as _row}
    <div class="row">
      {#each Array(4) as _column, index}
        <div class:margin-right={index !== 3}>
          <Skeleton --skeleton-height="12px" --skeleton-width="100%" --skeleton-radius="2px" />
        </div>
      {/each}
    </div>
  {/each}
</div>

<style>
  .table {
    display: grid;
  }
  .row {
    display: grid;
    grid-template-columns: 20% 55% 15% 10%;
    border-bottom: solid 1px var(--rk-divider-0);
    padding: 22px 0;
  }
  .margin-right {
    margin-right: 16px;
  }
</style>
